module.exports = __webpack_public_path__ + "static/media/sicbo-half.c4cc34f3.png";